import React, { useState, useEffect } from "react";

import {
  SimpleGrid,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  useDisclosure,
  Box,
  Flex,
  Text,
} from "@chakra-ui/react";

import { CustomButton } from "../../../../../components/CustomButton";
import RadioGroupTable from "../../../../../components/RadioGroupTable";
import { FiltersFiliacao } from "../../../../../components/FiltersFiliacao";
import { FiliacaoEditar } from "../../../Filiacao/Editar";
import { cpf } from "../../../../../utils/masks";
import LoadingSpinner from "../../../../../components/LoadingSpinner";

export const FiliacoesModal = ({
  props,
  isOpen,
  onOpen,
  onClose,
  filiacao,
  form,
  selected,
  setSelected,
  idPJ,
}) => {
  const {
    isOpen: isOpenEditar,
    onOpen: onOpenEditar,
    onClose: onCloseEditar,
  } = useDisclosure();

  const [data, setData] = useState();
  const [treatedData, setTreatedData] = useState();
  const [tempSelected, setTempSelected] = useState();
  const [loading, setLoading] = useState(false);
  const [loadingSelect, setLoadingSelect] = useState(false);
  const [vinculoBlocked, setVinculoBlocked] = useState(true);

  const columns = [
    {
      Header: "Nome",
      accessor: "nome",
      sortType: (rowA, rowB, id, desc) => {
        return rowA.original.nome.localeCompare(rowB.original.nome, "pt-BR");
      },
      Cell: (props) => {
        return <span title={props.value}>{props.value}</span>;
      },
    },
    {
      Header: "CPF",
      accessor: "cpf",
      Cell: (props) => {
        return <span>{props.value ? cpf(props.value) : ""}</span>;
      },
    },
    {
      Header: "Filho(a)",
      accessor: "criancasAgrupadas",
      Cell: (props) => {
        return (
          <React.Fragment>
            {props?.value?.map((crianca, index) => (
              <React.Fragment key={index}>
                {crianca.nomeFilho && (
                  <Box py={props.value.length === 1 && "17.3px"}>
                    <span style={{ whiteSpace: "nowrap" }}>
                      {crianca.nomeFilho}
                    </span>
                    <hr />
                  </Box>
                )}
                {crianca.nomeFilho &&
                  props.value.length - 1 !== index &&
                  props.value.length > 1 && <Box mt={4}></Box>}
              </React.Fragment>
            ))}
          </React.Fragment>
        );
      },
      disableSortBy: true,
    },
  ];

  useEffect(() => {
    if (data) {
      setTreatedData(data);
    } else {
      setTreatedData(null);
    }
    setTempSelected(null);
  }, [data]);

  const handleTemporarySelection = (value) => {
    setTempSelected(value);
  };

  const backAlert = (tempSelected, props) => {
    setLoadingSelect(true);

    const updatedTempSelected = {
      ...tempSelected,
      tipoFiliacao:
        filiacao && filiacao === "Mãe*"
          ? "Mãe"
          : filiacao && filiacao === "Pai*"
          ? "Pai"
          : "",
    };

    if (!filiacao) {
      setVinculoBlocked(false);
      onOpenEditar();
    } else {
      form.setFieldValue("filiacoes", [
        ...form.values.filiacoes,
        updatedTempSelected,
      ]);
      setTempSelected(null);
      setData(null);
      setTreatedData(null);
      onClose();
    }
    setLoadingSelect(false);
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={() => {
          setTempSelected(null);
          setData(null);
          setTreatedData(null);
          onClose();
        }}
        size="6xl"
        scrollBehavior={"inside"}
      >
        <ModalOverlay />
        <ModalContent
          p={{ base: "5px", sm: "15px", md: "25px" }}
          w={{ base: "100%", lg: "70%" }}
          bgColor="#FFF"
        >
          <ModalHeader
            p="0px"
            fontWeight={700}
            fontSize="14px"
            lineHeight="19.6px"
            color="#95BCBF"
          >
            {"Buscar".toUpperCase()}
          </ModalHeader>
          <ModalBody
            p="0px"
            mt="25px"
            minH={{ base: "0px", md: "200px" }}
            pl="1px"
          >
            <FiltersFiliacao
              filiacoes={selected}
              setFiliacoes={setSelected}
              form={form}
              setLoading={setLoading}
              setData={setData}
              initialFiliacao={filiacao}
              tempSelected={tempSelected}
              onOpenEditar={onOpenEditar}
              setSelected={handleTemporarySelection}
              onCloseFiliacoes={() => {
                setTempSelected(null);
                setData(null);
                onClose();
              }}
              idPJ={idPJ}
            />
            {!loading ? (
              <>
                {treatedData && (
                  <RadioGroupTable
                    data={treatedData}
                    columns={columns}
                    selected={selected}
                    filiacao={true}
                    setSelected={handleTemporarySelection}
                    hasOrdernation={true}
                  />
                )}
              </>
            ) : (
              <Box mt={4}>
                <LoadingSpinner />
              </Box>
            )}

            <Flex justifyContent="center" mt={10}>
              <Text color="#5F6377">
                CPF: O sistema pesquisará em todas as fichas de MCA a existência
                do CPF informado. <br /> Nome: O sistema pesquisará em todas as
                fichas de MCA filiações com nomes semelhantes.
              </Text>
            </Flex>
          </ModalBody>

          <ModalFooter
            p="0px"
            mt={{ base: "5px", sm: "15px" }}
            justifyContent="end"
          >
            <SimpleGrid
              mt="10px"
              columns={2}
              spacing="15px"
              w={{ base: "100%", lg: "40%" }}
            >
              <CustomButton
                onClick={() => {
                  setTempSelected(null);
                  setData(null);
                  setTreatedData(null);
                  onClose();
                }}
                label="Voltar"
              />
              <CustomButton
                onClick={() => backAlert(tempSelected, props)}
                isDisabled={!tempSelected}
                label="Selecionar"
                isLoading={loadingSelect}
              />
            </SimpleGrid>
            {tempSelected && (
              <FiliacaoEditar
                isOpen={isOpenEditar}
                onOpen={onOpenEditar}
                onClose={onCloseEditar}
                filiacoes={selected}
                selectedFiliacao={tempSelected}
                vinculoBlocked={vinculoBlocked}
                secondOnClose={(temp) => {
                  onCloseEditar();
                  if (temp) {
                    setSelected(temp);
                  }
                  setTempSelected(null);
                  setData(null);
                  setTreatedData(null);
                  onClose();
                }}
              />
            )}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
